module.exports = __webpack_public_path__ + "img/component_02_m.37ff16cd.png";